import {rejectedHeartRunnerListState} from '../state/rejectedHeartRunnerState';
import {Fetch_All_Region_Data1,Fetch_User_Rejected_List,Update_Request,Update_Delete_Response} from '../actions/rejectedHeartRunnerListAction';

export function rejectedHeartRunnerReducer(state = rejectedHeartRunnerListState, action) {
    switch (action.type) {

        case Fetch_User_Rejected_List : 
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                rejectedHeartRunnerList : action.rejectedList
            })
        case Update_Request:
            return Object.assign({}, state, {
                isLoading: false,
                errorCode : 0,
                statusCode : 0,
                message : ''
            })
        case Update_Delete_Response:
            return Object.assign({}, state, {
                rejectedHeartRunnerList: action.updatedList,
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message
            })
             case Fetch_All_Region_Data1:
                                            return Object.assign({}, state, {
                                                errorCode : action.errorCode,
                                                statusCode : action.statusCode,
                                                regionList : action.regionList
                                            })
        default:
            return state;
    }
}